import React from "react"
import {
    Box,
    componentStyles,
    Spinner,
    Spacer,
} from "@mallardbay/lib-react-components"

import TextLogo from "~components/shared/header/logo"
import { TEST_IDS } from "~config/constants"

export default function AuthenticatingLoader() {
    const styles = useStyles()
    return (
        <Box testId={TEST_IDS.AUTHENTICATING_LOADER} style={styles.container}>
            <Spinner />
            <Box>
                <Spacer />
                <TextLogo />
            </Box>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        container: {
            display: "flex",
            width: "100vw",
            height: "100vh",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },
    })
}
